import { CartUrl, BasketCartUrl, APIDownError } from "../directives/utilities/urls";
export default function duplicateCertificate() {
    return {
        isClearBalancePaymentBasket: false,
        isCandidacyVerification: false,
        candidacyVerificationFalseMessage: '',
        eValue: '',
        checkOutMessage:'',
        transcript: [],
        isDigital: false,
        isPaper: false,
        isDomesticFirstClassShipping: false,
        isInternationalShipping: false,
        isDomesticExpeditedShipping: false,
        message: '',
        passedSessionId: '',
        passedBasketId: '',
        passedName: '',
        passedCertificateProgram: '',
        passedAddress1: '',
        passedAddress2: '',
        passedAddress3: '',
        passedCity: '',
        passedState: '',
        passedZipCode: '',

        passedEmail: '',
        states: [],
        passedNameOnCertificate: '',

        isPassedName: false,
        isPassedNameError: '',
        isPassedEmail: false,
        isPassedEmailError: '',

        isPassedZipCode: false,
        isPassedZipCodeError: '',
        isPassedState: false,
        isPassedStateError: '',
        isPassedAddress2: false,
        isPassedAddress2Error: '',
        isPassedCity: false,
        isPassedCityError: '',
        isPassedAddress1: false,
        isPassedAddress1Error: '',
        isPassedName: false,
        isPassedNameError: '',
        isSuccessMessage: false,
        isPassedCertificateProgram: false,
        isPassedCertificateProgramError: '',
        isPassedNameOnCertificate: false,
        isPassedNameOnCertificateError: '',
        isShippingOption: false,
        isShippingOptionError: '',
        isPassedCertificateType: false,
        isPassedCertificateTypeError: '',
        isBasketRequestExists: false,
        isBasketRequestExistsError: '',
        shippingOptionPassed: '',
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        ClearBalancePaymentBasket() {

            fetch('/api/Basket/ClearBalancePaymentBasket', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.isClearBalancePaymentBasket = true;
                        if (this.passedBasketId <= 0) {
                            this.CertificateVerificationRequestCheck();
                        }
                    } else {
                        this.isClearBalancePaymentBasket = false;
                    }

                });
        },
        CertificateVerificationRequestCheck() {

            fetch('/api/Basket/CertificateRequestCheck', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess && response.allowed) {

                        this.isCandidacyVerification = true;
                        this.candidacyVerificationFalseMessage = "";
                    } else {
                        this.isCandidacyVerification = false;
                        this.candidacyVerificationFalseMessage = response.message;

                    }

                });
        },

        GetCertificateTranscript() {
            this.passedEmail = document.getElementById("hdnEmail").value;
            fetch('/api/StudentAPI/GetCertificateTranscript', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    BasketId: this.passedBasketId,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.transcript = response.transcript;
                        if (this.transcript != null) {
                            this.passedAddress1 = this.transcript.address1;
                            this.passedCertificateProgram = this.transcript.certificateName;
                            this.passedName = this.transcript.name;
                            this.passedCity = this.transcript.city;
                            this.passedNameOnCertificate = this.transcript.nameOnCertificate;
                            this.passedState = this.transcript.state;
                            this.passedZipCode = this.transcript.zipCode;
                            if (this.passedName === this.passedEmail) {
                                this.isDigital = true;
                                this.passedEmail = this.passedName;
                            }
                            else if (this.passedName != "" && this.passedName != this.passedEmail && this.passedAddress1 == "" && this.passedCity == "" && this.passedState == "" && this.passedZipCode == "") {
                                this.isDigital = true;
                                this.passedEmail = this.passedName;
                            }
                            else {
                                this.isPaper = true;
                            }
                            if (this.passedName != "" && this.passedAddress1 != "" && this.passedCity != "" && this.passedState != "" && this.passedZipCode != "") {
                                this.isPaper = true;
                                this.isDomesticFirstClassShipping = true;
                                this.isInternationalShipping = false;
                                this.isDomesticExpeditedShipping = false;
                            }
                            else if (this.passedName != "" && document.getElementById("shippingOptionPassed").value == "InternationMail") {
                                this.isPaper = true;
                                this.isDomesticFirstClassShipping = false;
                                this.isInternationalShipping = true;
                                this.isDomesticExpeditedShipping = false;
                            }
                            else if (this.passedName != "" && document.getElementById("shippingOptionPassed").value == "DomesticExpedited") {
                                this.isPaper = true;
                                this.isDomesticFirstClassShipping = false;
                                this.isInternationalShipping = false;
                                this.isDomesticExpeditedShipping = true;
                            }
                        }
                    } else {
                        this.isSuccessMessage = false;
                        this.message = APIDownError;
                    }

                });
        },
        getStates() {
            fetch('/api/common/getstates')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.states = json
                })
                .catch((error) => {
                    console.error(error);
                })
        },

        digitalClick() {
            this.isDigital = true;
            this.isPaper = false;
            this.message = "";
            this.passedAddress1 = "";
            this.passedName = "";
            this.passedCity = "";
            this.passedState = "";
            this.passedZipCode = "";
        },
        paperClick() {
            this.isPaper = true;
            this.isDigital = false;
            this.message = "";
            this.passedName = "";
        },
        domesticFirstClassShippingClick() {
            this.isDomesticFirstClassShipping = true;
            this.isInternationalShipping = false;
            this.isDomesticExpeditedShipping = false;
            this.message = "";
            this.shippingOptionPassed = "DomesticFirstClass";
        },
        internationalShippingClick() {
            this.isInternationalShipping = true;
            this.isDomesticFirstClassShipping = false;
            this.isDomesticExpeditedShipping = false;
            this.message = "";
            this.passedAddress1 = "";
            this.passedName = "";
            this.passedCity = "";
            this.passedState = "";
            this.passedZipCode = "";
            this.shippingOptionPassed = "InternationMail";
        },
        domesticExpeditedShippingClick() {
            this.isDomesticExpeditedShipping = true;
            this.isInternationalShipping = false;
            this.isDomesticFirstClassShipping = false;
            this.message = "";
            this.passedAddress1 = "";
            this.passedName = "";
            this.passedCity = "";
            this.passedState = "";
            this.passedZipCode = "";
            this.shippingOptionPassed = "DomesticExpedited";
        },
        SaveCertificateTranscript() {           
            let isValidRequest = true;
            if (this.passedCertificateProgram == "" || this.passedCertificateProgram == null) {
                this.isPassedCertificateProgram = true;
                this.isPassedCertificateProgramError = "Certificate program is required";
                this.message = "";
                isValidRequest = false;
            }
            else {
                this.isPassedCertificateProgram = false;
                this.isPassedCertificateProgramError = "";
            }
            if (this.passedNameOnCertificate == "" || this.passedNameOnCertificate == null) {
                this.isPassedNameOnCertificate = true;
                this.isPassedNameOnCertificateError = "Your name on certificate is required.";
                this.message = "";
                isValidRequest = false;
            }
            else {
                this.isPassedNameOnCertificate = false;
                this.isPassedNameOnCertificateError = "";
            }
            if (!this.isDigital && !this.isPaper) {
                this.isPassedCertificateType = true;
                this.isPassedCertificateTypeError = "Please check type of certificate requested.";
                this.message = "";
                isValidRequest = false;
            }
            else {
                this.isPassedCertificateType = true;
                this.isPassedCertificateTypeError = "";
            }

            if (!isValidRequest)
                return false;

            if (this.isDigital) {
                if (this.passedEmail == "") {
                    this.isPassedEmail = true;
                    this.isPassedEmailError = "Please enter email";
                    this.message = "";
                    isValidRequest = false;
                }
                else if (!this.isValidEmail(this.passedEmail)) {
                    this.isPassedEmail = true;
                    this.isPassedEmailError = "Please enter valid email";
                    this.message = "";
                    isValidRequest = false;
                }
                else {
                    this.isPassedEmail = false;
                    this.isPassedEmailError = "";
                    if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {

                        fetch('/api/StudentAPI/SaveCertificateTranscript', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({

                                BasketId: this.passedBasketId,
                                CertificateProgram: this.passedCertificateProgram,
                                NameOnCertificate: this.passedNameOnCertificate,
                                RequestType: 1,
                                ShippingOption: 0,
                                Name: "",
                                Address1: "",
                                City: "",
                                State: "",
                                ZipCode: "",
                                StudentEmail: this.passedEmail,

                            })
                        })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {
                                if (response.isSuccess) {
                                    this.isSuccessMessage = true;
                                    window.location.href = BasketCartUrl;
                                }else if (!response.isSuccess && response.checkoutTypeError) {
                                    this.checkOutMessage = response.message
                                    document.getElementById('btnCartCheckOutError').click();
                                }
                                else {
                                    this.isSuccessMessage = false;
                                    this.message = APIDownError;
                                }
                            });
                    }
                    else {
                        fetch('/api/Basket/CheckBasketRequestExists', { "method": "GET" })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response != undefined && response.isSuccess && response.requestExists) {

                                    this.isBasketRequestExists = true;
                                    this.isBasketRequestExistsError = "You have started one request, please <a href=\"/basket/basket-cart\" class=\"text-primary\">Click here</a> to continue or edit. Only one request can be processed at a time.";
                                } else {
                                    this.isBasketRequestExists = false;
                                    this.isBasketRequestExistsError = "";

                                }
                                if (!this.isBasketRequestExists) {
                                 
                                    fetch('/api/StudentAPI/SaveCertificateTranscript', {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({

                                            BasketId: this.passedBasketId,
                                            CertificateProgram: this.passedCertificateProgram,
                                            NameOnCertificate: this.passedNameOnCertificate,
                                            RequestType: 1,
                                            ShippingOption: 0,
                                            Name: "",
                                            Address1: "",
                                            City: "",
                                            State: "",
                                            ZipCode: "",
                                            StudentEmail: this.passedEmail,

                                        })
                                    })
                                        .then(response => {
                                            if (response.ok) {
                                                return response.json()
                                            }
                                        }).then(response => {

                                            if (response.isSuccess) {
                                                this.isSuccessMessage = true;
                                                window.location.href = BasketCartUrl;
                                            
                                        }else if (!response.isSuccess && response.checkoutTypeError) {
                                            this.checkOutMessage = response.message
                                            document.getElementById('btnCartCheckOutError').click();
                                        }
                                            else {
                                                this.isSuccessMessage = false;
                                                this.message = APIDownError;
                                            }

                                        });
                                }
                            });
                    }

                }
            }
            else if (this.isPaper) {
                if (!this.isDomesticFirstClassShipping && !this.isInternationalShipping && !this.isDomesticExpeditedShipping) {
                    this.isShippingOption = true;
                    this.isShippingOptionError = "Please check Shpipping Option for delivery of your paper certificate.";
                    this.message = "";
                }
                else {
                    this.isShippingOption = false;
                    this.isShippingOptionError = "";
                }
                if (this.isDomesticFirstClassShipping) {
                    if (this.passedName == "") {
                        this.isPassedName = true;
                        this.isPassedNameError = "Please enter Name";
                        this.message = "";
                    }
                    else {
                        this.isPassedName = false;
                        this.isPassedNameError = "";
                    }
                    if (this.passedAddress1 == "" || this.passedAddress1 == null) {
                        this.isPassedAddress1 = true;
                        this.isPassedAddress1Error = "Please enter Address";
                        this.message = "";
                    }
                    else {
                        this.isPassedAddress1 = false;
                        this.isPassedAddress1Error = "";
                    }
                    if (this.passedCity == "" || this.passedCity == null) {
                        this.isPassedCity = true;
                        this.isPassedCityError = "Please enter City";
                        this.message = "";
                    }
                    else {
                        this.isPassedCity = false;
                        this.isPassedCityError = "";
                    }
                    if (this.passedState == "" || this.passedState == null) {
                        this.isPassedState = true;
                        this.isPassedStateError = "Please select state";
                        this.message = "";
                    }
                    else {
                        this.isPassedState = false;
                        this.isPassedStateError = "";
                    }

                    if (this.passedZipCode == "" || this.passedZipCode == null) {
                        this.isPassedZipCode = true;
                        this.isPassedZipCodeError = "Please enter zip code";
                        this.message = "";
                    }
                    else {
                        this.isPassedZipCode = false;
                        this.isPassedZipCodeError = "";
                    }
                    if (!this.isPassedAddress1 && !this.isPassedCity && !this.isPassedState && !this.isPassedZipCode) {
                        if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {

                            fetch('/api/StudentAPI/SaveCertificateTranscript', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({

                                    BasketId: this.passedBasketId,
                                    CertificateProgram: this.passedCertificateProgram,
                                    NameOnCertificate: this.passedNameOnCertificate,
                                    RequestType: 2,
                                    ShippingOption: 1,
                                    Name: this.passedName,
                                    Address1: this.passedAddress1,
                                    City: this.passedCity,
                                    State: this.passedState,
                                    ZipCode: this.passedZipCode,
                                    StudentEmail: this.passedEmail,

                                })
                            })
                                .then(response => {
                                    if (response.ok) {
                                        return response.json()
                                    }
                                }).then(response => {

                                    if (response.isSuccess) {
                                        this.isSuccessMessage = true;
                                        window.location.href = BasketCartUrl;
                                    } else if (!response.isSuccess && response.checkoutTypeError) {
                                        this.checkOutMessage = response.message
                                        document.getElementById('btnCartCheckOutError').click();
                                    } else {
                                        this.isSuccessMessage = false;
                                        this.message = APIDownError;
                                    }

                                });


                        }
                        else {
                            fetch('/api/Basket/CheckBasketRequestExists', { "method": "GET" })
                                .then(response => {
                                    if (response.ok) {
                                        return response.json()
                                    }
                                }).then(response => {

                                    if (response != undefined && response.isSuccess && response.requestExists) {

                                        this.isBasketRequestExists = true;
                                        this.isBasketRequestExistsError = "You have started one request, please <a href=\"" + BasketCartUrl + "\" class=\"text-primary\">click here</a> to continue or edit. Only one request can be processed at a time.";
                                    } else {
                                        this.isBasketRequestExists = false;
                                        this.isBasketRequestExistsError = "";

                                    }
                                    if (!this.isBasketRequestExists) {
                                        fetch('/api/StudentAPI/SaveCertificateTranscript', {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({

                                                BasketId: this.passedBasketId,
                                                CertificateProgram: this.passedCertificateProgram,
                                                NameOnCertificate: this.passedNameOnCertificate,
                                                RequestType: 2,
                                                ShippingOption: 1,
                                                Name: this.passedName,
                                                Address1: this.passedAddress1,
                                                City: this.passedCity,
                                                State: this.passedState,
                                                ZipCode: this.passedZipCode,
                                                StudentEmail: this.passedEmail,

                                            })
                                        })
                                            .then(response => {
                                                if (response.ok) {
                                                    return response.json()
                                                }
                                            }).then(response => {

                                                if (response.isSuccess) {
                                                    this.isSuccessMessage = true;
                                                    window.location.href = BasketCartUrl;
                                            }else if (!response.isSuccess && response.checkoutTypeError) {
                                                this.checkOutMessage = response.message
                                                document.getElementById('btnCartCheckOutError').click();
                                            }
                                                else {
                                                    this.isSuccessMessage = false;
                                                    this.message = APIDownError;
                                                }

                                            });
                                    }

                                });
                        }

                    }
                }
                else if (this.isInternationalShipping) {
                    if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {
                        fetch('/api/StudentAPI/SaveCertificateTranscript', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({

                                BasketId: this.passedBasketId,
                                CertificateProgram: this.passedCertificateProgram,
                                NameOnCertificate: this.passedNameOnCertificate,
                                RequestType: 2,
                                ShippingOption: 2,
                                Name: this.passedName,
                                Address1: "",
                                City: "",
                                State: "",
                                ZipCode: "",
                                StudentEmail: this.passedEmail,

                            })
                        })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response.isSuccess) {
                                    this.isSuccessMessage = true;
                                    window.location.href = BasketCartUrl;
                            }else if (!response.isSuccess && response.checkoutTypeError) {
                                this.checkOutMessage = response.message
                                document.getElementById('btnCartCheckOutError').click();
                            }

                                else {
                                    this.isSuccessMessage = false;
                                    this.message = APIDownError;
                                }

                            });


                    }
                    else {
                        fetch('/api/Basket/CheckBasketRequestExists', { "method": "GET" })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response != undefined && response.isSuccess && response.requestExists) {

                                    this.isBasketRequestExists = true;
                                    this.isBasketRequestExistsError = "You have started one request, please <a href=\"" + BasketCartUrl + "\" class=\"text-primary\">click here</a> to continue or edit. Only one request can be processed at a time.";
                                } else {
                                    this.isBasketRequestExists = false;
                                    this.isBasketRequestExistsError = "";

                                }
                                if (!this.isBasketRequestExists) {
                                    fetch('/api/StudentAPI/SaveCertificateTranscript', {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({

                                            BasketId: this.passedBasketId,
                                            CertificateProgram: this.passedCertificateProgram,
                                            NameOnCertificate: this.passedNameOnCertificate,
                                            RequestType: 2,
                                            ShippingOption: 2,
                                            Name: this.passedName,
                                            Address1: "",
                                            City: "",
                                            State: "",
                                            ZipCode: "",
                                            StudentEmail: this.passedEmail,

                                        })
                                    })
                                        .then(response => {
                                            if (response.ok) {
                                                return response.json()
                                            }
                                        }).then(response => {

                                            if (response.isSuccess) {
                                                this.isSuccessMessage = true;
                                                window.location.href = BasketCartUrl;
                                            }
                                       else if (!response.isSuccess && response.checkoutTypeError) {
                                            this.checkOutMessage = response.message
                                            document.getElementById('btnCartCheckOutError').click();
                                        } 

                                            else {
                                                this.isSuccessMessage = false;
                                                this.message = APIDownError;
                                            }

                                        });
                                }
                            });
                    }

                }
                else if (this.isDomesticExpeditedShipping) {
                    if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {
                        fetch('/api/StudentAPI/SaveCertificateTranscript', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({

                                BasketId: this.passedBasketId,
                                CertificateProgram: this.passedCertificateProgram,
                                NameOnCertificate: this.passedNameOnCertificate,
                                RequestType: 2,
                                ShippingOption: 3,
                                Name: this.passedName,
                                Address1: "",
                                City: "",
                                State: "",
                                ZipCode: "",
                                StudentEmail: this.passedEmail,

                            })
                        })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response.isSuccess) {
                                    this.isSuccessMessage = true;
                                    window.location.href = BasketCartUrl;
                                }
                                else if (!response.isSuccess && response.checkoutTypeError) {
                                    this.checkOutMessage = response.message
                                    document.getElementById('btnCartCheckOutError').click();
                                }
                                else {
                                    this.isSuccessMessage = false;
                                    this.message = APIDownError;
                                }

                            });

                    }
                    else {

                        fetch('/api/Basket/CheckBasketRequestExists', { "method": "GET" })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response != undefined && response.isSuccess && response.requestExists) {

                                    this.isBasketRequestExists = true;
                                    this.isBasketRequestExistsError = "You have started one request, please <a href=\"" + BasketCartUrl + "\" class=\"text-primary\">click here</a> to continue or edit. Only one request can be processed at a time.";
                                } else {
                                    this.isBasketRequestExists = false;
                                    this.isBasketRequestExistsError = "";

                                }
                                if (!this.isBasketRequestExists) {
                                    fetch('/api/StudentAPI/SaveCertificateTranscript', {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({

                                            BasketId: this.passedBasketId,
                                            CertificateProgram: this.passedCertificateProgram,
                                            NameOnCertificate: this.passedNameOnCertificate,
                                            RequestType: 2,
                                            ShippingOption: 3,
                                            Name: this.passedName,
                                            Address1: "",
                                            City: "",
                                            State: "",
                                            ZipCode: "",
                                            StudentEmail: this.passedEmail,

                                        })
                                    })
                                        .then(response => {
                                            if (response.ok) {
                                                return response.json()
                                            }
                                        }).then(response => {

                                            if (response.isSuccess) {
                                                this.isSuccessMessage = true;
                                                window.location.href = BasketCartUrl;
                                            }
                                            else if (!response.isSuccess && response.checkoutTypeError) {
                                                this.checkOutMessage = response.message
                                                document.getElementById('btnCartCheckOutError').click();
                                            } 
                                            else {

                                                
                                                this.isSuccessMessage = false;
                                                this.message = APIDownError;
                                            }

                                        });
                                }

                            });


                    }

                }

            }
        },
        init() {
            this.ClearBalancePaymentBasket();
            this.getStates();
            this.passedBasketId = document.getElementById("BasketId").value;
            if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {
                this.isCandidacyVerification = true;
                this.GetCertificateTranscript();
            }

        }
    }
}